import { Capacitor } from '@capacitor/core';

export default {
  isAndroid(): boolean {
    return (
      Capacitor.isNativePlatform()
        && Capacitor.getPlatform() === 'android'
    );
  },
  isIOS(): boolean {
    return (
      Capacitor.isNativePlatform()
        && Capacitor.getPlatform() === 'ios'
    );
  },
  isAndroidOrIOS(): boolean {
    return this.isAndroid() || this.isIOS();
  },
  isWeb(): boolean {
    return !Capacitor.isNativePlatform();
  },
};
